
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Contacts",
      function () {
        return require("private-next-pages/Contacts/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Contacts"])
      });
    }
  